// L4 Subcollections pill rail: shows desktop arrows only when the pills overflow (sections/subcollections-slider.liquid).
if (!customElements.get('subcollection-pills')) {
  customElements.define(
    'subcollection-pills',
    class SubcollectionPills extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pills-track]');
        this.prev = this.querySelector('[data-pills-prev]');
        this.next = this.querySelector('[data-pills-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.update = this.update.bind(this);
        this.onPrev = () => this.scrollByPage(-1);
        this.onNext = () => this.scrollByPage(1);

        this.prev.hidden = false;
        this.next.hidden = false;
        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.track?.removeEventListener('scroll', this.update);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const overflowing = scrollWidth > clientWidth + 1;
        this.toggleAttribute('data-overflow', overflowing);
        this.prev.disabled = !overflowing || scrollLeft <= 1;
        this.next.disabled = !overflowing || scrollLeft + clientWidth >= scrollWidth - 1;
      }

      scrollByPage(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  );
}
